import React from 'react';

interface DonutChartProps {
  data: Array<{ label: string; value: number; color: string }>;
  size?: number;
  strokeWidth?: number;
  centerText?: string;
  centerSubtext?: string;
}

export const DonutChart: React.FC<DonutChartProps> = ({
  data,
  size = 120,
  strokeWidth = 8,
  centerText,
  centerSubtext
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const total = data.reduce((sum, item) => sum + item.value, 0);
  
  let offset = 0;

  // Filter out zero values for display
  const displayData = data.filter(item => item.value > 0);

  return (
    <div className="relative flex items-center justify-center">
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#f3f4f6"
          strokeWidth={strokeWidth}
        />
        {displayData.map((item, index) => {
          const strokeDasharray = total > 0 ? (item.value / total) * circumference : 0;
          const strokeDashoffset = -offset;
          offset += strokeDasharray;
          
          return (
            <circle
              key={index}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke={item.color}
              strokeWidth={strokeWidth}
              strokeDasharray={`${strokeDasharray} ${circumference}`}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="transition-all duration-300"
            />
          );
        })}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-xs font-medium text-gray-900">{centerText}</div>
        {centerSubtext && (
          <div className="text-xs text-gray-500 mt-1">{centerSubtext}</div>
        )}
      </div>
    </div>
  );
};

export default DonutChart;
